/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Anticipation_HelpInputs */



/**
* | output |
* | --- |
* | "Switches to Occupation mode to optimize the temperature rise of thermostatic heads" |
*
* @param {Anticipation_HelpInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const anticipation_help = /** @type {((inputs?: Anticipation_HelpInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Anticipation_HelpInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Switches to Occupation mode to optimize the temperature rise of thermostatic heads")
	return /** @type {LocalizedString} */ ("Le  bascule en mode Occupation pour optimiser la montée en chauffe des têtes thermostatiques")
});